// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionTopicEntity from './entities/petition-topic.json';
import petitionTopicMenu from '../pages/petition-topic/menu.json';
import petitionTopicFullForm from '../pages/petition-topic/forms/full.json';
import petitionTopicContextForm from '../pages/petition-topic/forms/context.json';
import petitionTopicMiniForm from '../pages/petition-topic/forms/mini.json';
import petitionTopicLookupForm from '../pages/petition-topic/forms/lookup.json';
import petitionTopicTableView from '../pages/petition-topic/views/table.json';
import petitionTopicDashboardView from '../pages/petition-topic/views/dashboard.json';

/** Тип запису «Тема петиції» зі сторінками пакета: меню, форми та подання з pages/petition-topic/. */
export const petitionTopicDefinition: IRecordTypeDefinition = {
  ...petitionTopicEntity,
  views: assembleViewSet({
      table: petitionTopicTableView,
      dashboard: petitionTopicDashboardView,
  }),
  form: petitionTopicFullForm,
  forms: { full: petitionTopicFullForm, context: petitionTopicContextForm, mini: petitionTopicMiniForm, lookup: petitionTopicLookupForm },
  menu: petitionTopicMenu,
} as IRecordTypeDefinition;
